<template>
  <div class="add-new-layer-card" @click="$emit('click')">
    <div class="add-icon">
      <icon>add</icon>
    </div>
    <div class="flex-col flex-expand mar-left-10">
      <h4 class="title">Create new layer</h4>
      <p class="description">Visualize your entities on map</p>
    </div>
    <icon type="box" size="18">keyboard_arrow_right</icon>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.add-new-layer-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px 5px 5px;
  margin: 5px 10px;
  border-radius: 5px;
  background: var(--color-secondary);
  transition: 0.3s all ease-in-out;

  .add-icon {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    background: var(--color-primary-light);
    color: var(--color-primary);
    pointer-events: none;
  }

  i {
    pointer-events: none;
  }

  .title {
    margin: 0;
    color: var(--color-primary);
  }
  .description {
    margin: 0;
    font-size: 0.8rem;
    opacity: 0.7;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 5px 10px #1210252a;
  }

  &:active {
    transform: scale(0.97);
  }
}
</style>
